import React, { Fragment, useState, useContext, useEffect } from 'react';

import {
    Grid,
    TextField,
    Button,
    Typography,
    Paper,
    Box
} from '@material-ui/core';

import Alert from '@material-ui/lab/Alert';
import { useStyles } from '../styles/CardStyles';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import NumberFormat from 'react-number-format';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';
import ReCAPTCHA from "react-google-recaptcha";

const ChangePinMain = () => {
    const classes = useStyles(); //Use Styles from styles/styles.js
    const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
    const notificationContext = useContext(NotificationContext);
    const {
        errors,
        clearErrors,
        loading,
        setAtmCardNumberDetails,
        getCardSessionValidation,
        cardSessionValidation,
        CheckifSoftLock,
        localIP
    } = documentUploadContext;

    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');

    const [captchaValue, setCaptchaValue] = useState('');

    const [atmCardNumber, setAtmCardNumber] = useState('');

    const onAtmCardNumberChange = (e) => setAtmCardNumber(e.target.value.replace(/[^0-9]/g, ""));

    const [selectedDate, setSelectedDate] = useState(null);
    const handleDataChange = (date) => {
      setSelectedDate(date);
    };
    const [inlineErrorMessage, setInlineErrorMessage] = useState('');

    const handleSubmitClick = (e) => {
        if (captchaValue == '')
        {
          
          //      setAtmCardNumberDetails(atmCardNumber, selectedDate);           
            setInlineErrorMessage('Please check the Captcha box.');
        }
        else {

            if (atmCardNumber == '')
            {
                setInlineErrorMessage('Please input 16 digit card number.');
            }
            else if (atmCardNumber.length < 16) {
                setInlineErrorMessage('Please input 16 digit card number.');
            }
             else if (atmCardNumber.substring(0,6) !== "536344") {
                //    setInlineErrorMessage('Please input 16 digit card number.');
                 //   notificationContext.setNotification(errors, 'Invalid Flexi Card number.');
                    setInlineErrorMessage('Invalid Flexi Card number.');
                } 

            else
            {
                if (CheckifSoftLock('FAILEDCARDVALIDATION', 'LOCKTIMEVALIDATION')) {
                    setAtmCardNumberDetails(atmCardNumber, '', selectedDate);
                }
            }
        }
    };

    useEffect(() => {
        if (errors != null) {
            notificationContext.setNotification(errors, 'error');
            clearErrors();
        }
    }, [errors]);

    
    useEffect(() => {
        if (localIP === '0.0.0.0') {
            CheckifSoftLock('FAILEDCARDVALIDATION', 'LOCKTIMEVALIDATION');
        }
    }, [localIP]);

    function onChange(value) {
      setCaptchaValue(value);
    }
    
    return (
        <div>
            <Header page={5} />
            <div className={classes.banner}>
                <Typography className={classes.paragraph}>
                    In order to proceed with change pin, please enter your 16-digit Flexi Card number:
                </Typography>
                <Fragment>
                    <Paper elevation={0} className={classes.paper}>
                        {loading ? (
                            <Spinner />
                        ) : (
                                <Fragment>
                                        <Grid container direction='row' spacing={3}>
                                        <Grid container md={3} item></Grid>
                                        <Grid container md={6} item>
                                            <p classes={classes.txtFldLbl}>16-digit Flexi Card number</p>
                                                <TextField
                                                    className={classes.txtField}
                                                    name='referenceNumber'
                                                    autoComplete='off'
                                                    id='referenceNumber'
                                                    variant='outlined'
                                                    type='text'
                                                    InputLabelProps={{ required: true }}
                                                    value={atmCardNumber}
                                                    onChange={onAtmCardNumberChange}
                                                    placeholder=""
                                                    inputProps={{ maxLength: 16, pattern: "[0-9]" }}
                                                    >
                                                </TextField>
                                        </Grid>
                                        <Grid container md={3} item></Grid>
                                        
                                        <Grid container direction='column' item>
                                        <Typography align='center'>
                                            For added security, please check the box below and click proceed button to continue
                                        </Typography>                                       
                                        <Grid container item alignItems='center' justify='center'>
                                            <Grid item>
                                                <Box mt={3}>
                                                    <ReCAPTCHA sitekey="6LfB-pMeAAAAALjtcXJUu8lafWtL9u9W3Fm78vC1" onChange={onChange}/>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        {/* <Grid container item alignItems='center' justify='center'>
                                            <Grid item>
                                                <Box mt={2}>
                                                    <Typography align='center'>
                                                        <div className={classes.inlineErrorMessage}>{inlineErrorMessage}</div>
                                                    </Typography> 
                                                </Box> 
                                            </Grid>
                                        </Grid> */}
                                        <Grid container item alignItems='center' justify='center'>
                                            <Grid item md={3} sm={4} xs={4}>
                                                <Button className={classes.button} variant='contained' color='primary' type='submit' onClick={handleSubmitClick}>Proceed</Button>
                                            </Grid>
                                        </Grid>
                                        <Grid container item >
                                            <Grid item>
                                                <Box mt={2}>
                                                    <Typography align='center'>
                                                        <div className={classes.inlineErrorMessage}>{inlineErrorMessage}</div>
                                                    </Typography> 
                                                </Box> 
                                            </Grid>
                                        </Grid>
                                        </Grid>
                                        
                                        </Grid>
                                </Fragment>
                            )}
                    </Paper>
                    <Notification/>
                </Fragment>
            </div>  
        </div>
    );
};

export default ChangePinMain;
